// AI Product Labeling — calls the ai-label edge function via trellis client.
// The OpenRouter API key lives server-side. No secrets in the frontend bundle.

import { api } from './api'

export interface AISuggestion {
  title_en: string
  title_fi: string
  description_en: string
  description_fi: string
  price?: number
  category?: string
}

/**
 * Get AI-generated product title, description, and price from an image.
 * Calls the `ai-label` trellis route (Supabase edge function).
 */
export async function getProductSuggestions(imageUrl: string): Promise<AISuggestion> {
  const data = await api.aiLabel.fetch({ imageUrl })

  return {
    title_en: data.title_en || '',
    title_fi: data.title_fi || '',
    description_en: data.description_en || '',
    description_fi: data.description_fi || '',
    price: data.price,
  }
}
